import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0bf52a8&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/home/vsts/work/1/a/NuxtApp/components/app/Breadcrumbs.vue').default,BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,CartSubmitButton: require('/home/vsts/work/1/a/NuxtApp/components/cart/SubmitButton.vue').default,CartEmptyBox: require('/home/vsts/work/1/a/NuxtApp/components/cart/EmptyBox.vue').default,CartLines: require('/home/vsts/work/1/a/NuxtApp/components/cart/Lines.vue').default,FormCartPromocode: require('/home/vsts/work/1/a/NuxtApp/components/form/CartPromocode.vue').default,WidgetsUSP: require('/home/vsts/work/1/a/NuxtApp/components/widgets/USP.vue').default,CartTotal: require('/home/vsts/work/1/a/NuxtApp/components/cart/Total.vue').default,BaseOverlay: require('/home/vsts/work/1/a/NuxtApp/components/base/Overlay.vue').default})
